<!-- WarningAssignModalFull.vue -->
<template>
  <div>
    <b-modal
        id="warning-assign"
        title="Cảnh báo"
        size="xl"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        @show="handleData"
    >
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form class="form" @submit.prevent>
          <p class="text-muted mb-3">
            Việc thay đổi lịch làm việc cố định sẽ dẫn tới sự thay đổi lịch đi làm kể từ ngày mai.
            Lịch đi làm mới đang ảnh hưởng tới tác vụ của nhân sự. Cần thay đổi người làm của các tác vụ dưới đây:
          </p>

          <el-table
              :data="rows"
              border
              height="420"
          >
            <el-table-column prop="code" label="Mã tác vụ" width="110" />
            <el-table-column label="Tác vụ" width="140">
              <template #default="{ row }">
                <el-tag :type="tagType(row.type)">{{ row.type }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="start" label="Thời gian bắt đầu" width="180" />
            <el-table-column prop="end" label="Thời gian kết thúc" width="180" />
            <el-table-column label="Thay đổi người làm" min-width="260">
              <template #default="{ row, $index }">
                <!-- Validate giống pattern bạn đang dùng -->
                <ValidationProvider
                    :name="`Nhân sự dòng ${$index+1}`"
                    rules="required"
                    :vid="`assign_${row.id ?? $index}`"
                    v-slot="{ errors }"
                >
                  <div :class="['assign-wrapper', {'has-error': errors[0]}]">
                    <el-select
                        v-model="row.idAdmin"
                        placeholder="Chọn nhân sự Admin"
                        filterable
                        clearable
                        class="w-100"
                        :loading="loadingStaff"
                    >
                      <el-option
                          v-for="u in row?.availableAdmin"
                          :key="u.admin_profile_id"
                          :label="u.user_name"
                          :value="u.admin_profile_id"
                      />
                    </el-select>
                    <div class="fv-help-block" v-if="errors[0]">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </template>
            </el-table-column>
          </el-table>

          <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-secondary mr-3" @click="closeModal">Đóng</button>
            <button
                type="button"
                class="btn btn-primary"
                :disabled="submitting"
                @click="handleSubmit(onConfirm)"
            >
              {{ submitting ? 'Đang xử lý...' : 'Đổi người phụ trách' }}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
// VeeValidate v3
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required as requiredRule } from 'vee-validate/dist/rules';
import {nextTick} from "vue";
import {REASSIGN_TUTOR} from "@/core/services/store/tutor/tutor.module";
export default  {
  name: 'WarningChangeTutor',
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      loadingStaff: false,
      // ===== State render/validate =====
      rows: [],
      assignments: {}, // { [taskId]: staffId }
      submitting: false
    };
  },
  props:{
    dataNeedChange:{
      type: Array,
      default: ()=> []
    },
    idTutor:{
      type: Number,
      default:()=>null
    }
  },
  methods: {
    handleData() {
      nextTick(()=>{
        this.rows = this.dataNeedChange.map((data)=>({
          id: data?.task_id,
          code: data?.task_id,
          type: data?.task_name,
          start: `${data?.start_time} ${data?.date}`,
          end: `${data?.end_time} ${data?.date}`,
          availableAdmin: data?.suitable_admins??[],
          idAdmin: null
        }))
      })
    },
    tagType(type) {
      const t = (type || '').toLowerCase();
      if (t.includes('gia sư')) return 'danger';
      if (t.includes('coi thi')) return 'warning';
      return 'info';
    },
    closeModal() {
      this.$bvModal.hide('warning-assign');
    },
    async onConfirm() {
      const ok = await this.$refs.observer.validate();
      if (!ok) return;

      this.submitting = true;
      try {
         const payload = {
           id: this.idTutor,
           data: {
             reassignments: this.rows.map((row)=>({
               task_id: row.code,
               new_admin_id: row.idAdmin
             }))
           }
         }
         await this.$store.dispatch(REASSIGN_TUTOR,payload)
         this.$message.success('Đã cập nhật người phụ trách.');
        this.closeModal();
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.w-100{ width:100%; }
.assign-wrapper .fv-help-block{
  color:#f56c6c; margin-top:4px; font-size:12px;
}
.assign-wrapper.has-error :deep(.el-input__inner){
  border-color:#f56c6c;
}
:deep(.row-error) td{
  background:#fff6f7;
}
</style>
